import {Component, Inject } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { TranslateContext } from '@shared/pipes/translate.pipe';

@Component({
	selector: 'amd-dialog-readonly',
	templateUrl: './dialog-readonly.component.html',
	styleUrls: ['./dialog-readonly.component.scss']
})
export class DialogReadonlyComponent {

	obj: IDialogReadonlyComponentData = {};
	t: TranslateContext = TranslateContext.SHARED;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: IDialogReadonlyComponentData,
		private dialogRef: MatDialogRef<DialogReadonlyComponent>,
	) {	
		this.obj = this.data;
	}
	
	onClose(): void {
		this.dialogRef.close();
	}
}

export interface IDialogReadonlyComponentData {
	title?: 	 		 string,
	content?: 		 string,
	template?: 		 any,
	closeButton?:  string,
	data?:  			 any,
};
